<mat-card-header class="flex-shrink-0 flex justify-between items-center p-4 border-b"
    [style.background-color]="getColorScheme()" [style.color]="getTextColor()">
    <mat-card-title class="text-lg font-semibold m-0">Select a Card</mat-card-title>
    <button mat-icon-button (click)="close()" matTooltip="Close" class="close-button" [style.color]="getTextColor()">
        <mat-icon>close</mat-icon>
    </button>
</mat-card-header>
<mat-card class="w-full h-full flex flex-col">

    
    <mat-card-content class="flex-1 overflow-y-auto p-0" style="max-height: calc(60vh - 120px);">
        <div class="card-list">
            <div *ngFor="let card of cards" class="card-item cursor-pointer w-full mb-2" (click)="selectCard(card)">
                <div class="w-full flex items-center justify-between p-3 rounded border hover:bg-gray-50">
                    <div class="flex items-center flex-1 min-w-0">
                        <img 
                            [src]="getCardLogo(card).logo" 
                            [alt]="getCardLogo(card).alt"
                            class="card-logo mr-3 h-6 w-8 sm:h-8 sm:w-10 object-contain flex-shrink-0"
                            onerror="this.style.display='none'; this.nextElementSibling.style.display='inline'"
                        />
                        <mat-icon 
                            class="mr-3 text-lg sm:text-xl hidden-when-logo flex-shrink-0" 
                            [style.display]="'none'">
                            payment
                        </mat-icon>
                        <div class="card-info flex-1 min-w-0">
                            <span class="card-number">{{getFormattedCardNumber(card.cardNumber)}}</span>
                            <span class="card-details">{{getCardLogo(card).type}} • Expires {{card.cardExpiryMonth}}/{{card.cardExpiryYear}}</span>
                        </div>
                    </div>
                    <div class="flex-shrink-0 ml-3">
                        <mat-icon 
                            class="cursor-pointer delete text-lg sm:text-xl" 
                            (click)="deleteCard(card); $event.stopPropagation()"
                            matTooltip="Delete card">
                            delete_forever
                        </mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
    
    <mat-card-actions class="flex-shrink-0 flex justify-center items-center p-4 border-t">
        <button mat-raised-button [disabled]="loading" (click)="addNewCard()" class="w-full sm:w-auto px-8">
            Add New Card
        </button>
    </mat-card-actions>
</mat-card>

